import {
  type NonCustomOnboardingTourStepOption,
  type OnboardingTourStep,
  type Profile,
  type SupportedOnboardingTourStep,
  mapToNonCustomOnboardingTourStepOption,
} from 'models';
import { useMemo } from 'react';

export const useSupportedOnboardingTourSteps = ({ steps, viewer }: { steps: OnboardingTourStep[]; viewer: Profile }) =>
  useMemo(() => {
    const remainingSteps: SupportedOnboardingTourStep[] = [];

    for (const step of steps) {
      const localStep = mapToNonCustomOnboardingTourStepOption(step.type);

      if (isValidStep(localStep, viewer)) {
        remainingSteps.push({
          data: step,
          step: localStep,
        });
      }
    }

    return remainingSteps.toSorted((step1, step2) => step1.data.order - step2.data.order);
  }, [viewer, steps]);

const isValidStep = (
  step: NonCustomOnboardingTourStepOption | undefined,
  viewer: Profile,
): step is NonCustomOnboardingTourStepOption => {
  if (!step) {
    return false;
  }

  if (step === 'consents' && viewer.requiredConsents.length === 0) {
    return false;
  }

  return true;
};
